var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { staticClass: "h1 font-weight-bold" }, [
      _vm._v("Beliebte Suchen")
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "popular-search-list",
        staticStyle: { "font-size": "16px", "padding-bottom": "20px" }
      },
      [
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/beliebte-suchen/nrw/") } },
          [_vm._v("Beliebte Suchen in NRW")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: _vm.regionRelativeUrl("/beliebte-suchen/niedersachsen/")
            }
          },
          [_vm._v("Beliebte Suchen in Niedersachsen")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/augsburg/") } }, [
          _vm._v("Sex in Augsburg")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/augsburg/") } },
          [_vm._v("Huren in Augsburg")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/berlin/") } }, [
          _vm._v("Sex in Berlin")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/berlin/") } }, [
          _vm._v("Huren in Berlin")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/bremen/") } }, [
          _vm._v("Sex in Bremen")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/bremen/") } }, [
          _vm._v("Huren in Bremen")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/chemnitz/") } }, [
          _vm._v("Sex in Chemnitz")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/chemnitz/") } },
          [_vm._v("Huren in Chemnitz")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/darmstadt/") } }, [
          _vm._v("Sex in Darmstadt")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/darmstadt/") } },
          [_vm._v("Huren in Darmstadt")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/dresden/") } }, [
          _vm._v("Sex in Dresden")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/dresden/") } }, [
          _vm._v("Huren in Dresden")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/erfurt/") } }, [
          _vm._v("Sex in Erfurt")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/erfurt/") } }, [
          _vm._v("Huren in Erfurt")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/frankfurt/") } }, [
          _vm._v("Sex in Frankfurt")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/frankfurt/") } },
          [_vm._v("Huren in Frankfurt")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: _vm.regionRelativeUrl("/sex/freiburg-im-breisgau/") }
          },
          [_vm._v("Sex in Freiburg")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: _vm.regionRelativeUrl("/huren/freiburg-im-breisgau/")
            }
          },
          [_vm._v("Huren in Freiburg")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/sex/halle-saale/") } },
          [_vm._v("Sex in Halle (Saale)")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/halle-saale/") } },
          [_vm._v("Huren in Halle (Saale)")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/hamburg/") } }, [
          _vm._v("Sex in Hamburg")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/hamburg/") } }, [
          _vm._v("Huren in Hamburg")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/sex/heidelberg/") } },
          [_vm._v("Sex in Heidelberg")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/heidelberg/") } },
          [_vm._v("Huren in Heidelberg")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/karlsruhe/") } }, [
          _vm._v("Sex in Karlsruhe")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/karlsruhe/") } },
          [_vm._v("Huren in Karlsruhe")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/kassel/") } }, [
          _vm._v("Sex in Kassel")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/kassel/") } }, [
          _vm._v("Huren in Kassel")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/kiel/") } }, [
          _vm._v("Sex in Kiel")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/kiel/") } }, [
          _vm._v("Huren in Kiel")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/leipzig/") } }, [
          _vm._v("Sex in Leipzig")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/leipzig/") } }, [
          _vm._v("Huren in Leipzig")
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: _vm.regionRelativeUrl("/sex/ludwigshafen-am-rhein/")
            }
          },
          [_vm._v("Sex in Ludwigshafen-Am-Rhein")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: _vm.regionRelativeUrl("/huren/ludwigshafen-am-rhein/")
            }
          },
          [_vm._v("Huren in Ludwigshafen-Am-Rhein")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/luebeck/") } }, [
          _vm._v("Sex in Lübeck")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/luebeck/") } }, [
          _vm._v("Huren in Lübeck")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/magdeburg/") } }, [
          _vm._v("Sex in Magdeburg")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/magdeburg/") } },
          [_vm._v("Huren in Magdeburg")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/mainz/") } }, [
          _vm._v("Sex in Mainz")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/mainz/") } }, [
          _vm._v("Huren in Mainz")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/mannheim/") } }, [
          _vm._v("Sex in Mannheim")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/mannheim/") } },
          [_vm._v("Huren in Mannheim")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/muenchen/") } }, [
          _vm._v("Sex in München")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/muenchen/") } },
          [_vm._v("Huren in München")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/nuernberg/") } }, [
          _vm._v("Sex in Nuernberg")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/nuernberg/") } },
          [_vm._v("Huren in Nuernberg")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/potsdam/") } }, [
          _vm._v("Sex in Potsdam")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/potsdam/") } }, [
          _vm._v("Huren in Potsdam")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/sex/regensburg/") } },
          [_vm._v("Sex in Regensburg")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/regensburg/") } },
          [_vm._v("Huren in Regensburg")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/rostock/") } }, [
          _vm._v("Sex in Rostock")
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/huren/rostock/") } }, [
          _vm._v("Huren in Rostock")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/sex/saarbruecken/") } },
          [_vm._v("Sex in Saarbrücken")]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/saarbruecken/") } },
          [_vm._v("Huren in Saarbrücken")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/stuttgart/") } }, [
          _vm._v("Sex in Stuttgart")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/stuttgart/") } },
          [_vm._v("Huren in Stuttgart")]
        ),
        _vm._v(" "),
        _c("a", { attrs: { href: _vm.regionRelativeUrl("/sex/wiesbaden/") } }, [
          _vm._v("Sex in Wiesbaden")
        ]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: _vm.regionRelativeUrl("/huren/wiesbaden/") } },
          [_vm._v("Huren in Wiesbaden")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa0ecec0", { render: render, staticRenderFns: staticRenderFns })
  }
}